const popups = {
    data () {
        return {
            popup: {
                active: false,
                content: '',
                status: ''
            }
        }
    },
    methods: {
        showPopup (data) {
            this.popup.active = data.popup
            if (data.text) {
                this.popup.content = data.text
            } else {
                this.popup.content = ''
            }

            if (data.popup == 'logs') {
                this.getLogs(data)
            }
        },
        closePopup () {
            this.popup.active = false
        },
        getLogs (data) {
            this.popup.content = ''
            return new Promise((resolve, reject) => {
                this.popup.status = 'loading'
                this.axios.get('api/admin/v2/log', {
                    params: {
                        entity_name: data.type,
                        entity_id: data.id,
                        field: data.field
                    }
                }).then((resp) => {
                    this.popup.status = ''
                    this.popup.content = resp.data.response

                    resolve()
                }).catch(() => {
                    this.popup.status = ''
                    let msg = {
                        message: 'Ошибка при получении логов',
                        status: 'error'
                    }
                    this.$store.dispatch('utils/showMessage', msg)
                    reject()
                })
            })
        }
    }
}

export default popups